/**
 * EmailAttachContext — lets any descendant component (e.g. AttachmentsSection's
 * "Email" button) trigger the same parse → preview → upload pipeline that
 * the page-level EmailDropZone owns.
 *
 * The context is null when no EmailDropZone is in the tree, which lets
 * AttachmentsSection conditionally hide its Email button — saves a "this
 * does nothing here" UX trap on pages that haven't opted in.
 */

import { createContext, useContext } from 'react';

export interface EmailAttachController {
  /** Run the parse/preview flow against a user-picked or dropped file. */
  trigger: (file: File) => void;
}

export const EmailAttachContext = createContext<EmailAttachController | null>(
  null,
);

export function useEmailAttachController(): EmailAttachController | null {
  return useContext(EmailAttachContext);
}
